module.exports = __webpack_public_path__ + "static/img/mens_art_vehicle.f83fa5e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blocks/mens_art_vehicle.svg
// module id = RPxq
// module chunks = 0